
import { CalculatorFormValues } from '../schema';
import { YearlyContribution } from './types';

export function calculateProjection(
  data: CalculatorFormValues,
  incomeContribution: number,
  assetContributions: {
    primaryResidence: number;
    otherProperties: number;
    farmBusiness: number;
    cash: number;
  },
  WEEKS_IN_YEAR: number
): YearlyContribution[] {
  const yearlyProjection: YearlyContribution[] = [];
  
  for (let year = 1; year <= 5; year++) {
    const effectiveYear = year + data.yearsInCare;
    
    // Determine if primary residence is still being assessed (3-year cap)
    let primaryResidenceForYear = 0;
    if (data.ownsPrimaryResidence && effectiveYear <= 3) {
      primaryResidenceForYear = assetContributions.primaryResidence;
    }
    
    // Determine if farm/business is still being assessed (3-year cap if family successor)
    let farmBusinessForYear = 0;
    if (data.hasFarmOrBusiness) {
      if (!data.familySuccessor || effectiveYear <= 3) {
        farmBusinessForYear = assetContributions.farmBusiness;
      }
    }
    
    // Calculate year's asset contribution
    const yearAssetContribution = assetContributions.cash + 
                                primaryResidenceForYear + 
                                assetContributions.otherProperties + 
                                farmBusinessForYear;
    
    // Calculate year's total contribution
    const yearTotalAnnual = incomeContribution + yearAssetContribution;
    const yearTotalWeekly = yearTotalAnnual / WEEKS_IN_YEAR;
    
    // Calculate deferred amount for this year
    let yearDeferredAmount = 0;
    if (data.useLoan) {
      const deferredPropertyForYear = (primaryResidenceForYear + 
                                     assetContributions.otherProperties + 
                                     (data.familySuccessor ? farmBusinessForYear : 0)) / WEEKS_IN_YEAR;
      yearDeferredAmount = deferredPropertyForYear;
    }
    
    // Calculate State support for this year
    let yearStateSupport = null;
    if (data.nursingHomeCost > 0) {
      const effectiveContribution = Math.min(yearTotalWeekly, data.nursingHomeCost);
      yearStateSupport = Math.max(0, data.nursingHomeCost - effectiveContribution);
      
      if (yearTotalWeekly > data.nursingHomeCost) {
        yearStateSupport = 0;
      }
    }
    
    yearlyProjection.push({
      year,
      totalAnnual: yearTotalAnnual,
      totalWeekly: yearTotalWeekly,
      incomeContribution: incomeContribution / WEEKS_IN_YEAR,
      assetContribution: yearAssetContribution / WEEKS_IN_YEAR,
      primaryResidenceContribution: primaryResidenceForYear / WEEKS_IN_YEAR,
      otherPropertiesContribution: assetContributions.otherProperties / WEEKS_IN_YEAR,
      farmBusinessContribution: farmBusinessForYear / WEEKS_IN_YEAR,
      deferredAmount: yearDeferredAmount,
      stateSupport: yearStateSupport
    });
  }
  
  return yearlyProjection;
}
